import React, {Component} from 'react'
import Logo from '../assets/img/logo/logo.svg'
import * as requestLib from '../lib/requestLib' 

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = { 

        };

        this.baseUrl = requestLib.getUrl(); 

    }


    render() {
        return (
            <div className="header">
                <h1>
                    <a href={this.baseUrl}>
                        <img src={Logo}/>
                    </a>
                </h1>
            </div>
        )
    }
}


export default Header; 

